import {
    CONTROL_PANEL_SIDEBAR_OPEN_UPDATE,
    CONTROL_PANEL_SIDEBAR_OPEN,
    CONTROL_PANEL_SIDEBAR_CLOSE,
} from "../action-types/controlPanelSidebar"

const sidebarInit = {
    openComponent: process.env.SPARCA_CONTROL_PANEL_SIDEBAR_ICONS_SELECT,
    close: true,
}

export default function controlPanelSidebarReducer(state = sidebarInit, action) {
    switch (action.type) {
        case CONTROL_PANEL_SIDEBAR_OPEN_UPDATE: {
            return {
                ...state,
                openComponent: action.payload,
                close: false,
            }
        }
        case CONTROL_PANEL_SIDEBAR_OPEN: {
            return { ...state, close: false }
        }
        case CONTROL_PANEL_SIDEBAR_CLOSE: {
            return { ...state, close: true }
        }
        default:
            return state
    }
}
